// AlignUI · иллюстрация пустого состояния: пустой кошелёк с купюрами
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationДеньги(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 148' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M111.6 65.2315V78.6982C111.6 74.4374 108.15 70.9944 103.897 70.9944H38.9624C35.3931 70.9944 32.4781 68.2135 32.2477 64.7112C32.5153 60.6956 35.8615 57.5278 39.9364 57.5278H103.897C108.15 57.5278 111.6 60.9706 111.6 65.2315Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M67.5614 21.2672L38.3249 58.0968C36.863 59.9384 37.1708 62.6165 39.0124 64.0784L61.3625 81.8206C63.2041 83.2825 65.8822 82.9747 67.3442 81.1331L96.5806 44.3035C98.0425 42.4618 97.7347 39.7838 95.8931 38.3218L73.543 20.5797C71.7014 19.1177 69.0233 19.4255 67.5614 21.2672Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M75.7583 22.3375L41.2277 65.8363L47.1997 70.5771L81.7303 27.0783L75.7583 22.3375Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M90.0836 32.6743L50.0993 57.4219C48.0999 58.6594 47.4823 61.2834 48.7198 63.2828L63.7379 87.5473C64.9754 89.5467 67.5994 90.1644 69.5987 88.9269L109.583 64.1793C111.582 62.9418 112.2 60.3178 110.963 58.3184L95.9445 34.0539C94.707 32.0545 92.083 31.4369 90.0836 32.6743Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M94.6146 46.2637L87.1944 50.8563C86.3639 51.3704 86.1073 52.4604 86.6213 53.291L89.4322 57.8324C89.9462 58.663 91.0363 58.9195 91.8668 58.4055L99.2871 53.8129C100.118 53.2988 100.374 52.2088 99.8601 51.3782L97.0493 46.8368C96.5352 46.0062 95.4452 45.7496 94.6146 46.2637Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M111.601 78.6982V115.001C111.601 119.262 108.15 122.705 103.897 122.705H39.9367C35.6833 122.705 32.233 119.262 32.233 115.001V65.2314C32.233 65.0531 32.2405 64.8821 32.2479 64.7111C32.4783 68.2134 35.3934 70.9943 38.9626 70.9943H103.897C108.15 70.9943 111.601 74.4374 111.601 78.6982Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M112.575 91.5698H97.474C95.7108 91.5698 94.2814 92.9992 94.2814 94.7625V101.296C94.2814 103.06 95.7108 104.489 97.474 104.489H112.575C114.338 104.489 115.768 103.06 115.768 101.296V94.7625C115.768 92.9992 114.338 91.5698 112.575 91.5698Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M100.798 100.785C102.32 100.785 103.553 99.5515 103.553 98.0298C103.553 96.5081 102.32 95.2745 100.798 95.2745C99.2762 95.2745 98.0426 96.5081 98.0426 98.0298C98.0426 99.5515 99.2762 100.785 100.798 100.785Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M90.7638 67.8197V71.0049H80.3676V67.8197C80.3676 64.9488 82.6949 62.6251 85.5657 62.6251C87.0029 62.6251 88.3015 63.2051 89.2426 64.1463C90.1838 65.0839 90.7638 66.3823 90.7638 67.8197Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M85.566 62.6251C82.6952 62.6251 80.3679 64.9488 80.3679 67.8197V97.7668C80.3679 101.269 77.5299 104.107 74.0244 104.107C70.5225 104.107 67.6808 101.269 67.6808 97.7668C67.6808 94.8121 69.7017 92.328 72.4375 91.6241L47.111 96.844L47.0891 96.8476L46.8811 96.8841C45.2323 97.2343 43.9957 98.7007 43.9957 100.455V67.8197C43.9957 64.9488 46.323 62.6251 49.1938 62.6251H85.566Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-sub-300'
        d='M74.0243 104.106H47.6471C45.6299 104.106 43.9957 102.472 43.9957 100.455C43.9957 98.7005 45.2323 97.2341 46.8811 96.8839L47.0891 96.8474L47.111 96.8438L72.4375 91.6239C69.7017 92.3279 67.6808 94.812 67.6808 97.7667C67.6808 101.269 70.5224 104.106 74.0243 104.106Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M74.0243 104.106H47.6471C45.6299 104.106 43.9957 102.472 43.9957 100.455C43.9957 98.7005 45.2323 97.2341 46.8811 96.8839L47.0891 96.8474L47.111 96.8438L72.4375 91.6239C69.7017 92.3279 67.6808 94.812 67.6808 97.7667C67.6808 101.269 70.5224 104.106 74.0243 104.106Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0'
        d='M52.661 74.8411L57.5407 79.7152L52.661 74.8411Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M52.661 74.8411L57.5407 79.7152'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0'
        d='M57.5385 74.8382L52.6644 79.7179L57.5385 74.8382Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M57.5385 74.8382L52.6644 79.7179'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0'
        d='M67.5592 74.8325L72.4389 79.7064L67.5592 74.8325Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M67.5592 74.8325L72.4389 79.7064'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0'
        d='M72.4359 74.8295L67.5619 79.7092L72.4359 74.8295Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M72.4359 74.8295L67.5619 79.7092'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0'
        d='M55.7091 84.7298L68.3539 84.7225L55.7091 84.7298Z'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M55.7091 84.7298L68.3539 84.7225'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M25.5717 43.1338C25.5717 43.1338 19.5644 41.3442 17.7605 47.3251C19.5643 41.3443 13.5692 39.5138 13.5692 39.5138C13.5692 39.5138 19.5766 41.3034 21.3805 35.3226C19.5766 41.3034 25.5717 43.1338 25.5717 43.1338Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M135.607 79.4648C135.607 79.4648 130.476 85.4836 136.457 90.6169C130.476 85.4835 125.305 91.4672 125.305 91.4672C125.305 91.4672 130.436 85.4484 124.455 80.315C130.436 85.4484 135.607 79.4648 135.607 79.4648Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
